module.exports = __webpack_public_path__ + "static/media/API_RealtimeAvailability_Prerequisite@2x.0eec7da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/guides/RealTimeAvailability/API_RealtimeAvailability_Prerequisite@2x.png
// module id = 1477
// module chunks = 0